import { Component, inject } from '@angular/core';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { RobotSideaComponent } from '@components/robots/sidea/sidea.component';
import { SettingService } from '@services/setting.service';
import { MenuModule } from 'primeng/menu';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DrawerModule } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { ProviderService } from '@services/provider.service';
import { ToastService } from '@utils/toast.service';
import { ShowForRolesDirective } from '@directives/show-for-roles.directive';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';

@Component({
  selector: 'app-platform',
  imports: [
    BackboneComponent,
    BreadcrumbComponent,
    RobotSideaComponent,
    MenuModule,
    RouterModule,
    CommonModule,
    AccordionModule,
    TableModule,
    ButtonModule,
    TagModule,
    DrawerModule,
    InputTextModule,
    SelectModule,
    InputNumberModule,
    FormsModule,
    ShowForPermissionsDirective,
  ],
  templateUrl: './platform.component.html',
  styleUrl: './platform.component.scss',
})
export class PlatformPage {
  private settingService = inject(SettingService);
  private providerService = inject(ProviderService);
  private toastService = inject(ToastService);

  public robotSideaList = [];
  public robotSideaDrawerOpen: boolean = false;
  public robotSideaFormSaving: boolean = false;
  public robotSideaForm = {
    nameCurp: '',
    nameBot: '',
    interval: 0,
    limit: 0,
  };

  public providersList = [];
  public providerDrawerOpen: boolean = false;
  public providerModuleList = [
    { label: 'IMSS - CONSULTAR NSS', value: 'imss-consultar-nss' },
    { label: 'IMSS - SEMANAS COTIZADAS', value: 'imss-semanas-cotizadas' },
    { label: 'IMSS - VIGENCIA DE DERECHO', value: 'imss-vigencia-derecho' },
    { label: 'IMSS - NO DERECHOHABIENTE', value: 'imss-no-derechohabiente' },
    { label: 'REGISTRO CIVIL - ACTOS', value: 'registro-civil-actos' },
    { label: 'REGISTRO CIVIL - DIGITALIZACIÓN', value: 'registro-civil-digitalizacion' },
    { label: 'REGISTRO CIVIL - CORRECCIÓN DE ACTA', value: 'registro-civil-correccion-acta' },
    { label: 'SAT - CONSTANCIA DE SITUACIÓN FISCAL', value: 'sat-constancia-situacion-fiscal' },
    { label: 'SAT - OPINIÓN DEL CUMPLIMIENTO', value: 'sat-opinion-cumplimiento' },
    { label: 'SAT - CÉDULA DE IDENTIFICACIÓN FISCAL', value: 'sat-cedula-identificacion-fiscal' },
    { label: 'SAT - RECUPERACIÓN DE CFDI', value: 'sat-recuperacion-cfdi' },
    { label: 'SAT - RECUPERACIÓN DE DECLARACIÓN', value: 'sat-recuperacion-declaracion' },
    { label: 'SAT - CITA PERSONA FÍSICA', value: 'sat-cita-persona-fisica' },
    { label: 'SAT - CITA PERSONA MORAL', value: 'sat-cita-persona-moral' },
    { label: 'SAT - ALTA RFC POR PRIMERA VEZ CON CONTRASEÑA', value: 'sat-alta-rfc-primera-vez-con-contrasena' },
    { label: 'SAT - ALTA RFC POR PRIMERA VEZ SIN CONTRASEÑA', value: 'sat-alta-rfc-primera-vez-sin-contrasena' },
    { label: 'SAT - CONTRASEÑA CIEC CON INE', value: 'sat-contrasena-ciec-ine' },
    { label: 'RENAPO - CURP', value: 'renapo-curp' },
    { label: 'RENAPO - CORRECCIÓN DE CURP', value: 'renapo-correccion-curp' },
    { label: 'RENAPO - UNIFICACIÓN DE CURP', value: 'renapo-unificacion-curp' },
    { label: 'RENAPO - CERTIFICACIÓN DE CURP', value: 'renapo-certificacion-curp' },
    { label: 'ISSSTE - TALÓN DE PAGOS', value: 'issste-talon-pagos' },
    { label: 'ISSSTE - CONSTANCIA DE ACREDITACIÓN DE NO AFILIACIÓN', value: 'issste-constancia-acreditacion-no-afiliacion' },
    { label: 'CFE - RECIBO DE LUZ', value: 'cfe-recibo-de-luz' },
  ];
  public providerFormSaving: boolean = false;
  public providerForm = {
    provider: '',
    module: '',
    cost: 0,
  };

  public editValue: any = {
    onEdit: false,
    name: '',
    price: '',
  };

  async ngOnInit() {
    this.getRobotSideaList();
    this.getProviderList();
  }

  public openDrawer = (event: Event, drawer: string) => {
    event.stopPropagation();

    switch (drawer) {
      case 'robotSidea':
        this.robotSideaDrawerOpen = true;
        break;

      case 'provider':
        this.providerDrawerOpen = true;
        break;
    }
  };

  public closeDrawer = (drawer: string) => {
    switch (drawer) {
      case 'robotSidea':
        this.robotSideaDrawerOpen = false;
        break;

      case 'provider':
        this.providerDrawerOpen = false;
        this.providerFormSaving = false;
        this.providerForm = {
          provider: '',
          module: '',
          cost: 0,
        };
        break;
    }
  };

  public getRobotSideaList = () => {
    this.settingService.robotSideaList().then((response: any) => (this.robotSideaList = response));
  };

  public onRobotDeleted = (id: number) => {
    this.robotSideaList = this.robotSideaList.filter((item: any) => item.id !== id);
  };

  public getSeverity = (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return 'success';

      case 'INACTIVE':
        return 'secondary';

      default:
        return null;
    }
  };

  public getStatus = (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return 'Activo';

      case 'INACTIVE':
        return 'Inactivo';

      default:
        return 'Desconocido';
    }
  };

  public getModule = (value: string): string | undefined => {
    const item = this.providerModuleList.find((item) => item.value === value);
    return item?.label ?? 'Módulo no encontrado';
  };

  public getProviderList = () => {
    this.providerService.list().then((response: any) => (this.providersList = response));
  };

  public saveProvider = () => {
    this.providerFormSaving = true;

    let body = {
      provider: this.providerForm.provider,
      module: this.providerForm.module,
      cost: this.providerForm.cost,
    };

    this.providerService.create(body).then((response: any) => {
      this.getProviderList();
      this.closeDrawer('provider');
      this.toastService.success('El proveedor se ha creado correctamente');
    });
  };

  public saveRobotSidea = () => {
    this.robotSideaFormSaving = true;

    let body = {
      nameCurp: this.robotSideaForm.nameCurp,
      nameBot: this.robotSideaForm.nameBot,
      interval: this.robotSideaForm.interval,
      limit: this.robotSideaForm.limit,
    };

    this.settingService.robotSideaCreate(body).then((response: any) => {
      this.getRobotSideaList();
      this.closeDrawer('robotSidea');
      this.toastService.success('El robot SIDEA se ha creado correctamente');
    });
  };

  onRowEditInit(item: any) {
    this.editValue.onEdit = true;
    this.editValue.name = item.provider;
    this.editValue.price = item.cost;
  }

  onRowEditSave(item: any) {
    item.provider = this.editValue.name;
    item.cost = this.editValue.price;

    this.providerService
      .update(item.id, {
        provider: this.editValue.name,
        cost: this.editValue.price,
      })
      .then((response: any) => this.toastService.success('El proveedor se ha actualizado correctamente'))
      .finally(() => {
        this.editValue.onEdit = false;
        this.editValue.name = '';
        this.editValue.price = '';
      });
  }

  onRowEditCancel(item: any, index: number) {
    this.editValue.onEdit = false;
    this.editValue.name = '';
    this.editValue.price = '';
  }
}
